import axios, { AxiosResponse } from 'axios'

const RECORD_API_URL = 'https://analytics-watches-jewelry-mini.chanel.com.cn'
// const RECORD_API_URL = 'https://dev.api.c.ripplex.cc'
// const RECORD_API_URL = ''

const request = axios.create({
  baseURL: RECORD_API_URL, // 设置基础URL
  timeout: 20000 // 设置请求超时时间
})

export interface IRecordParams {
  actionNo: number
  actionValue: string
  source: string
  actionType: number
  description: string
  openId: string
  unionId: string
  tag: string
  scene: string
}

export const record = (params: IRecordParams): Promise<AxiosResponse> =>
  request.get('/analytics-surface/record', { params })
